import { create } from 'apisauce';
import { combineEpics } from 'redux-observable';
import { loginTypes } from '../redux/loginStore';
import { Observable } from 'rxjs';

const api = create({baseURL : 'http://localhost:8080'})

const login = (action$)=>{
    return action$.ofType('LL')
        .mergeMap((action)=>{
            const token = action.token;
            return Observable.fromPromise(api.post('/auth',{token},{headers:{'Content-type':'application/json' }}))
            .catch(err=>{
                return Observable.of({type:'error'})
            })
        })
        .map((resp)=>({ type : 'AA', user : resp.data}))
        .catch((err)=>{console.log(err)})

}

export default combineEpics(login);


// WEBPACK FOOTER //
// ./src/epics/loginEpic.js